const DETAILS_ACTION_TYPES = {
  FETCH_DETAILS: "FETCH_COURSE_DETAILS",
  FETCH_DETAILS_REQUEST: "FETCH_COURSE_DETAILS_REQUEST",
  FETCH_DETAILS_SUCCESS: "FETCH_COURSE_DETAILS_SUCCESS",
  FETCH_DETAILS_FAILURE: "FETCH_COURSE_DETAILS_FAILURE",
  INVALIDATE_DETAILS: "INVALIDATE_COURSE_DETAILS",
}

export default DETAILS_ACTION_TYPES
